"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryRightHandPanelState = arbitraryRightHandPanelState;
exports.arbitraryUserUiState = arbitraryUserUiState;
const constants_1 = require("@buildwithflux/constants");
const fast_check_1 = require("fast-check");
function arbitraryRightHandPanelState(constraints = {}) {
    return (0, fast_check_1.record)({
        tabState: constraints.tabState
            ? (0, fast_check_1.constant)(constraints.tabState)
            : (0, fast_check_1.constantFrom)(constants_1.RightEditorDrawerTabState.inspector, constants_1.RightEditorDrawerTabState.copilotChat),
    });
}
function arbitraryUserUiState(constraints = {}, userRightHandPanelStateConstraints = {}) {
    return (0, fast_check_1.record)({
        userUid: constraints.userUid ? (0, fast_check_1.constant)(constraints.userUid) : (0, fast_check_1.uuid)(),
        rightHandPanelState: arbitraryRightHandPanelState(userRightHandPanelStateConstraints),
    });
}
//# sourceMappingURL=userUiState.js.map